<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'crmcustomerForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {

			// beforeSubmit(formData, next) {
			// 	if (Array.isArray(formData.city)) {
			// 		formData.city = formData.city[formData.city.length - 1]
			// 	}
			// 	next()
			// },
			// beforeRender(res) {
			// 	res.city = this.fApi.el('city').getRelationValue(res.city)
			// },
			// afterGet(res) {
			// 	this.fApi.exec('$son_customer_info', 'loadData', {
			// 		data: res.customer_info
			// 	})
			// },
			regestEvent() {
				// let $son_crmcustomer_order = this.fApi.el('$son_crmcustomer_order')
				// $son_crmcustomer_order.gridOptions.showFooter = true
				// $son_crmcustomer_order.footerField =  [{
				// 	field: 'realPayment',
				// 	toFixed: 4
				// }]
			},
			// beforeSubmit(formData,next){
			// 	delete(formData.$son_crmcustomer_flowup)
			// 	delete(formData.$son_crmcustomer_order)
			// 	delete(formData.$son_recommend)
			// 	next()
			// }
			// provincecityareaChange(e) {
			// 	let formData  = this.fApi.bind()
			// 	formData.house = ''
			// 	this.fApi.exec('house', 'areaChange', {
			// 		area: e
			// 	})
			// 	this.getFulladdress()
			// },
			// customerInfoAdd(e) {
			// 	e.table.insertAt({}, -1)
			// },
			// customerInfoDel(e) {
			// 	e.table.remove(e.row)
			// },
			// getFulladdress(e,field) {
			// 	let houseid = this.fApi.getValue('house')
			// 	let room = this.fApi.getValue('room')	
			// 	if(field=='house'){
			// 		houseid = e
			// 	}
			// 	if(field=='room'){
			// 		room = e
			// 	}
			// 	let house = this.fApi.exec('house', 'id2fulladdress', houseid)
			// 	this.$nextTick(()=>{
			// 		this.fApi.setValue({
			// 			fulladdress: house + room
			// 		})
			// 	})
			// }
		},
		components: {

		}
	}
</script>
